import React from 'react';
import { useTranslation } from 'react-i18next';
import './css/PrivacyPolicy.css';

function AiUsagePolicy() {
  const { t } = useTranslation();

  const sections = Array.from({ length: 5 }, (_, i) => i + 1);

  return (
    <div className="privacy-policy-container">
      <h2>{t('aiUsage.title')}</h2>
      <p className="privacy-effective-date">{t('aiUsage.effectiveDate')}</p>

      {sections.map(num => (
        <section key={num} className="privacy-section">
          <h3>{t(`aiUsage.section${num}.title`)}</h3>
          <div className="privacy-content">
            {t(`aiUsage.section${num}.content`).split('\n').map((line, idx) => {
              const boldMatch = line.match(/^\*\*(.+)\*\*$/);
              if (boldMatch) {
                return <p key={idx} className="ai-usage-subtitle">{boldMatch[1]}</p>;
              }
              return <p key={idx}>{line}</p>;
            })}
          </div>
        </section>
      ))}
    </div>
  );
}

export default AiUsagePolicy;
